import TaskApi from "../../service/TaskService";
import ProcessApi from "../../service/ProcessService";
import PreferenceApi from "../../service/PreferenceService";

import AddNoteRequest from "../../service/request/AddNoteRequest";
import GetMyActiveTaskRequest from "../../service/request/GetMyActiveTaskRequest";

export default {
  name: "AddNoteDialog",
  props: {
    processId: {
      type: String,
      required: true
    }
  },
  mixins: [],
  computed: {
    rules: function() {
      return {
        categoryRequired: v =>
          !!v || this.$t("category") + " " + this.$t("fieldRequired"),
        descriptionRequired: v =>
          !!v || this.$t("description") + " " + this.$t("fieldRequired")
      };
    }
  },
  data: function() {
    return {
      selectedCategory: null,
      categories: [],
      description: "",
      isRetrievingCategories: false,
      isAddingNoteInProgress: false
    };
  },
  created() {
    this.SHOW = true;
  },
  beforeMount: async function() {
    this.retrieveCategories();
  },
  methods: {
    onClickCancel() {
      this.close();
    },
    retrieveCategories() {
      this.isRetrievingCategories = true;
      PreferenceApi.getAllByMnemonic(
        this,
        "NOTE_CATEGORY",
        response => {
          this.isRetrievingCategories = false;
          if (response && response.result) {
            this.categories = response.result;
            this.categories.forEach(category => {
              category.value = this.$t(category.value);
            });
          }
        },
        error => {
          this.isRetrievingCategories = false;
          console.log(error, "getAllByMnemonic error");
        }
      );
    },
    onClickAddNote() {
      const isValid = this.$refs.addNoteDialogForm.validate();
      if (isValid) {
        this.isAddingNoteInProgress = true;

        const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
        getMyActiveTaskRequest.processId = this.processId;

        TaskApi.getMyActiveTask(
          this,
          getMyActiveTaskRequest,
          response => {
            const addNoteRequest = new AddNoteRequest();
            addNoteRequest.category = this.selectedCategory;
            addNoteRequest.description = this.description;
            addNoteRequest.processId = response.activeResourceTask.processId;

            ProcessApi.addNote(
              this,
              addNoteRequest,
              () => {
                this.isAddingNoteInProgress = false;
                this.close();
              },
              error => {
                console.log(error, "error-addNote");
                this.isAddingNoteInProgress = false;
              }
            );
          },
          error => {
            console.log(error);
            this.isDroppingAssigneeInProgress = false;
          }
        );
      }
    },
    close() {
      this.$emit("onClickCloseAddNoteDialog");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/AddNoteDialog.js